<template lang="html">
  <Input :icon="icon" v-model="val" :style="'text-align:right'" :disabled="disabled"/>
</template>

<script>
export default {
  props: ['value', 'icon', 'right', 'disabled'],
  data () {
    return {
      val: '',
    }
  },

  mounted () {
    this.fixValue()
  },

  methods: {
    fixValue () {
      this.val = !this.value ? '' : (parseFloat(this.value) || 0).toFixed(2).replace('.', ',')
    },
    fixed (v) {
      if (!v || v == '-') v = 0
      var fixed = parseFloat((''+v).replace(',', '.'))
      if (isNaN(fixed)) {
        console.log('nan')
        this.val = fixed = 0
      }
      return fixed
    },
  },

  watch: {
    value (v) {
      if (v == this.fixed(this.val)) return
      console.log('changed input')
      this.val = v
      this.fixValue()
    },
    val (v) {
      let fixed = this.fixed(v)
      this.$emit('input', fixed)
    }
  }
}
</script>

<style lang="css">
</style>
